export const gridSpacing = 3;
export const drawerWidth = 240;
export const appDrawerWidth = 320;
export const utc_time_zone = "+04:00";
